export default __webpack_public_path__ + "static/media/Hats09.ab450ca5.png";